import type { ContestState } from './state-pill';

const MINUTE = 60_000;
const HOUR = 3_600_000;
const DAY = 86_400_000;

/** "3h 27m" under a day, "1d 4h" once a full day has passed, "45m" under an hour. */
export function formatDuration(ms: number): string {
  const days = Math.floor(ms / DAY);
  if (days >= 1) return `${days}d ${Math.floor((ms % DAY) / HOUR)}h`;
  const hours = Math.floor(ms / HOUR);
  if (hours >= 1) return `${hours}h ${Math.floor((ms % HOUR) / MINUTE)}m`;
  return `${Math.floor(ms / MINUTE)}m`;
}

export interface TimeInStatusContest {
  readonly state: ContestState;
  readonly createdAt: string;
  readonly finalisedAt: string | null;
  readonly opensAt: string;
  readonly closesAt: string | null;
}

/**
 * Elapsed time since this Contest entered its current state (admin-ui.md list "Time in
 * status"). AdminContest carries no actual state-transition timestamps beyond
 * createdAt/finalisedAt/opensAt/closesAt (see contests/schedule-rail.ts), so this uses the
 * best-available proxy per state; Settled and Canceled have no timestamp source at all.
 */
export function timeInStatusMs(contest: TimeInStatusContest, now: Date): number | null {
  const since = timeInStatusSince(contest);
  return since === null ? null : now.getTime() - new Date(since).getTime();
}

function timeInStatusSince(contest: TimeInStatusContest): string | null {
  switch (contest.state) {
    case 'Scheduled':
      return contest.finalisedAt ?? contest.createdAt;
    case 'Open':
      return contest.opensAt;
    case 'Closed':
      return contest.closesAt;
    default:
      return null;
  }
}
